import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import { Link } from 'gatsby'

interface BaseCardListProps {
  items: {
    name: string
    logo: string | null
    logoUrl: string | null
    link: string
  }[]
  title: string
}

const baseCardList = ({ items, title }: BaseCardListProps) => {
  if (items && items.length === 0) {
    return null
  }

  return (
    <div>
      <div className="p-4">
        <h2 className="mb-2 text-lg font-semibold text-left text-night">
          {title}
        </h2>
        <ul className="">
          {items?.map((tool) =>
            tool ? (
              <li key={tool?.name}>
                <Link
                  to={tool.link}
                  target="_blank"
                  className="flex flex-row items-center gap-1 my-1 text-sm"
                >
                  <div className="flex items-center object-contain w-8 h-8 rounded-2xl">
                    {tool.logo &&
                      typeof tool.logo !== 'string' &&
                      'images' in tool.logo && (
                        <GatsbyImage
                          image={tool.logo}
                          alt={tool?.name ?? 'Outil'}
                        />
                      )}
                    {tool.logo && typeof tool.logo === 'string' && (
                      <img src={tool.logo} alt={tool?.name ?? 'Outil'} />
                    )}
                    {!tool.logo && tool.logoUrl && (
                      <img src={tool.logoUrl} alt={tool?.name ?? 'Outil'} />
                    )}
                    {!tool.logo && !tool.logoUrl && (
                      <img
                        src="../../../Logo_V_Lamacompta.jpg"
                        alt="Logo par défaut de l'outil"
                      />
                    )}
                  </div>
                  <div className="h-8 flex items-center ml-2 lg:text-[16px] text-[14px]">
                    {tool?.name}
                  </div>
                </Link>
              </li>
            ) : null,
          )}
        </ul>
      </div>
    </div>
  )
}

export default baseCardList
